import React from 'react';
import { useT, UT } from '@transifex/react';
import Stack from '@mui/material/Stack';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Checkbox, Typography, renderHTMLTags } from '@raisin/components-lib';

export const RememberDeviceConsentComponent = ({ onConsentChange }) => {
  const t = useT();
  return (
    <FormControlLabel
      style={{ width: '80%' }}
      name="rememberDeviceConsent"
      control={
        <Checkbox
          style={{ alignSelf: 'start' }}
          color="primary"
          defaultChecked
          onChange={(e) => {
            onConsentChange(e.target.checked);
          }}
        />
      }
      label={
        <Stack spacing={2}>
          <Typography textAlign="left">{t('login.form.rememberDevice.label')}</Typography>
          <Typography textAlign="left" variant="body2">
            <UT _str="login.form.rememberDevice.description" {...renderHTMLTags} />
          </Typography>
        </Stack>
      }
    />
  );
};
